<template>
    <Button v-bind="$attrs" :type="btnType" v-on="$listeners">
        <slot></slot>
        <CustomIcon
            v-if="!useNormalIcon"
            :type="type"
            size="16"
            style="vertical-align: -1px"
        />
        <Icon
            v-if="useNormalIcon"
            :type="type"
            size="16"
            class="handle-item-icon"
        />
    </Button>
</template>

<script>
import CustomIcon from '@/components/CustomIcon';
export default {
    name: 'GlobalButton',
    components: { CustomIcon },
    props: {
        type: {
            type: String,
            default: null,
        },
        btnType: {
            type: String,
            default: 'text',
        },
        // 是否使用常规Icon组件
        useNormalIcon: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped></style>
